<!--
	Brand logo from a `?raw` asset in $lib/assets/logos: wordmark in the text colour, `.mark` paths in brand red.
	Sized by its container's height.
-->
<script lang="ts">
	interface Props {
		/** Raw SVG from $lib/assets/logos (trusted static asset). */
		svg: string;
	}

	const { svg }: Props = $props();
</script>

<span class="logo">{@html svg}</span>

<style>
	.logo {
		display: block;
		height: 100%;
		color: var(--text-color);

		:global(svg) {
			width: auto;
			max-width: 100%;
			height: 100%;
		}

		:global(.mark) {
			fill: var(--accent);
		}
	}
</style>
